import React, { useState } from 'react'
import "./Profile.css";
import { FaCircleUser } from 'react-icons/fa6';
import { FaUserTie } from "react-icons/fa";

import { MdKeyboardArrowRight } from 'react-icons/md';
import { BsFillBoxSeamFill } from 'react-icons/bs';
import { IoMdCall } from 'react-icons/io';
import { FaUserTimes } from 'react-icons/fa';
import ProfileBanner from '../MobileComponent/PageBanner';
import { getProfile, getToken } from "../../services/localStorageServices";
import { useDispatch, useSelector } from "react-redux";

import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header';

const Profile = () => {
    const navigate = useNavigate();
    const { access_token } = getToken();
    const { token } = useSelector((state) => state.auth);
    const { profile } = getProfile();
    const dispatch = useDispatch();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const handleLogout = () => {
        // window.confirm('are you sure you want to logout')
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("profile");
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
    };
    
    return (
        <>
            {/* <ProfileBanner bannerName={'My Profile'} leftIcon="" rightIcon={<FaCircleUser />} /> */}
            <section>
                <div className='container'>
                    <div className='profile-page-all-detail'>
                        <span className='profile-page-name-icon'>
                            <Link to='/my-profile'>
                                <label> <label className='profile-page-icon'> <FaUserTie /> </label> User Profile</label>
                                <label className='profile-page-icon-arrow'><MdKeyboardArrowRight />                            </label>
                            </Link>
                        </span>
                        <span className='profile-page-name-icon'>
                            <Link to='/profiles/orders'>
                                <label> <label className='profile-page-icon'> <BsFillBoxSeamFill /> </label>  Orders </label>
                                <label className='profile-page-icon-arrow'><MdKeyboardArrowRight /> </label>
                            </Link>
                        </span>
                        <span className='profile-page-name-icon'>
                            <Link to='/best-diamond-dealer'>
                                <label> <label className='profile-page-icon'> <IoMdCall /></label>  Contact Services </label>
                                <label className='profile-page-icon-arrow'><MdKeyboardArrowRight /></label>
                            </Link>
                        </span>
                    </div>
                    <div>
                        <button className='profile-page-log-out' onClick={() => handleLogout()}> Logout </button>
                    </div>
                </div>
            </section>

            <Header />
        </>
    )
}

export default Profile